import "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as a } from "../../../../context/theme/hooks.js";
import u from "../../../../styles/colors/surfaces/useStateColor.js";
function $({
  tone: o,
  disabled: c,
  blend: r,
  fill: n
}) {
  const t = a(), l = d(o, c, t);
  return r ? f(o, c, t) : n === "filledTonal" ? i(o, c, t) : l;
}
function i(o, c, r) {
  const n = r[`${o}-low-surface`], t = r[`${o}-xLow-content`], l = r[`${o}-high-content`], s = c ? void 0 : {
    backgroundColor: r[`${o}-medium-surface`],
    borderColor: r[`${o}-low-content`]
  }, e = c ? void 0 : {
    backgroundColor: r[`${o}-high-surface`],
    borderColor: r[`${o}-high-surface`],
    color: r[`contentOn-${o}-high-surface`]
  };
  return {
    backgroundColor: n,
    borderColor: t,
    color: l,
    hoverStyles: s,
    activeStyles: e
  };
}
function d(o, c, r) {
  const n = r[`${o}-high-surface`], t = r[`contentOn-${o}-high-surface`], l = u(n, "hover"), s = u(n, "active");
  return {
    backgroundColor: n,
    borderColor: n,
    color: t,
    hoverStyles: c ? void 0 : {
      backgroundColor: l,
      borderColor: l
    },
    activeStyles: c ? void 0 : {
      backgroundColor: s,
      borderColor: s
    }
  };
}
function f(o, c = !1, r) {
  const n = "transparent", t = "transparent", l = r[`${o}-high-content`], s = c ? void 0 : {
    backgroundColor: r[`${o}-low-surface`]
  }, e = c ? void 0 : {
    backgroundColor: r[`${o}-medium-surface`]
  };
  return {
    backgroundColor: n,
    borderColor: t,
    color: l,
    hoverStyles: s,
    activeStyles: e
  };
}
export {
  $ as default
};
